import { render, staticRenderFns } from "./Retrieval.vue?vue&type=template&id=2deb64b0&scoped=true&"
import script from "./Retrieval.vue?vue&type=script&lang=js&"
export * from "./Retrieval.vue?vue&type=script&lang=js&"
import style0 from "./Retrieval.vue?vue&type=style&index=0&id=2deb64b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb64b0",
  null
  
)

export default component.exports